import { FC, useRef, useState } from "react"
import ReactCrop, { Crop, centerCrop, makeAspectCrop } from "react-image-crop"

import { MUIIcon } from "../../../../../widgets"
import { canvasPreview } from "./canvasPreview"
import { useDebounceEffect } from "./useDebounceEffect"

interface Step2Props {
    image: string
    setImage: (image: string) => void
    moveNext?: () => void
    moveBack?: () => void
}

export const Step2: FC<Step2Props> = ({ image, setImage, moveNext, moveBack }) => {
    const [crop, setCrop] = useState<Crop>();
    const [completedCrop, setCompletedCrop] = useState<Crop>();

    const [aspect] = useState<number>()
    const imgRef = useRef<HTMLImageElement>(null)
    const previewCanvasRef = useRef<HTMLCanvasElement>(null)
    const [scale] = useState(1)
    const [rotate] = useState(0)

    const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement>) => {
        const { naturalWidth: width, naturalHeight: height } = e.currentTarget

        const crop = centerCrop(
            makeAspectCrop({ unit: '%', width: 90 }, 3 / 4, width - 2, height - 2),
            width,
            height
        )

        setCrop(crop)
    }

    useDebounceEffect(async () => {
        if (
            completedCrop?.width &&
            completedCrop?.height &&
            imgRef.current &&
            previewCanvasRef.current
        ) {
            canvasPreview(
                imgRef.current,
                previewCanvasRef.current,
                completedCrop,
                scale,
                rotate,
            )
        }
    }, 100, [completedCrop, scale, rotate])

    const getImageAndMoveNext = () => {
        const canvas = document.createElement('canvas')
        canvasPreview(imgRef.current!, canvas, completedCrop!, scale, rotate)

        canvas.toBlob((blob) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                const imageString = reader.result as string;
                console.log(imageString);
                setImage(imageString)
                moveNext && moveNext();
            };
            reader.readAsDataURL(blob!);
        }, "image/jpeg");
    }

    return (
        <div className='card bg-light border'>
            <div className='card-body d-flex flex-row gap-3'>
                <div>
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                        onComplete={(c) => setCompletedCrop(c)}
                        aspect={aspect}
                        minHeight={100}
                    >
                        <img
                            ref={imgRef}
                            src={image}
                            alt="Captured"
                            className="object-contain"
                            style={{ objectFit: 'contain' }}
                            onLoad={onImageLoad} />
                    </ReactCrop>
                </div>
                <div className=''>
                    <canvas
                        ref={previewCanvasRef}
                        className='border border-1 object-contain p-2 w-100px bg-white'
                    />
                </div>
            </div>
            <div className='card-footer border-gray-300 d-flex gap-3 py-3'>
                <button
                    className='btn btn-sm btn-link link-primary'
                    onClick={() => (moveBack && moveBack())}>
                    <MUIIcon iconName='ArrowBackOutlined' /> Back
                </button>
                <div className='flex-fill' />
                <button
                    className='btn btn-sm btn-link link-primary'
                    onClick={() => getImageAndMoveNext()}>
                    Next <MUIIcon iconName='ArrowForwardOutlined' />
                </button>
            </div>
        </div>
    )
}
